// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".move-form__tab[data-v-7c50150c] {\n  padding-top: 6px;\n}\n", ""]);
// Exports
module.exports = exports;
